import * as remoteAction from "../remoteAction";

export type AccountCreditRedeemActionParam =
  | "shopify.giftCard"
  | "shopify.discount";

export type AccountCreditRedeemActionSuccess =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REDEEM_SUCCESS", any>;
export type AccountCreditRedeemActionFailure =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REDEEM_FAILURE", any>;
export type AccountCreditRedeemActionRequest =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REDEEM_REQUEST", any>;

export interface AccountCreditRedeemAction
  extends remoteAction.PostRemoteRequest {
  types: {
    request: "ACCOUNT_CREDIT_REDEEM_REQUEST";
    success: "ACCOUNT_CREDIT_REDEEM_SUCCESS";
    failure: "ACCOUNT_CREDIT_REDEEM_FAILURE";
  };
}

export interface AccountCreditRedeemParams {
  action: AccountCreditRedeemActionParam;
  amount: number;
  currency: string;
}

export const accountCreditRedeem = ({
  action,
  amount,
  currency = "USD",
}: AccountCreditRedeemParams): AccountCreditRedeemAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "ACCOUNT_CREDIT_REDEEM_REQUEST",
    failure: "ACCOUNT_CREDIT_REDEEM_FAILURE",
    success: "ACCOUNT_CREDIT_REDEEM_SUCCESS",
  },
  method: "POST",
  https: true,
  data: {
    action,
    amount,
    currency,
  },
  url: `/rewards/redeem/v2`,
});
